import React, { Component } from 'react';
import firebase from '../../store/firebase';
import FiveBarHistogram from './FiveBarHistogram'

// Material-UI imports
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid'; // optional, for better layout
import { isMobile } from 'react-device-detect'

class TotalsDashboard extends Component {
  state = {
    totalLc: null,
    totalGif: null,
    MEVav: null,
    WALLETCInUSD: null,
    MEVprice: null,
    bnbPrice: null,  
    gif30: null,        // ← new: store the fetched price
    TOTpledge: null,
    totalBNB: null,
    dayLim: null,
    loading: true,
    error: null,
    customMeVPrice: '',      // controlled input value
    appliedCustomPrice: null, // the price actually used for projections
    daysPassed: null,
    daysLeft: null,
    totalBNBInUSD: null,
    loadingfetch: false,
    lcOut: null,
    MEVbuy: null,
    MEVsold: null,
    TOTgif: null,
    TokensBuy: null,
    TokensSpent: null,
    Lcfallback: null,
  };

  async componentDidMount() {
    try {
      const data = await this.getTotals();
      const cdays = await this.getMonthProgress();
      await this.fetchData();

      console.log('getTotals 0');
      console.log('cdays daysPassed: ', cdays.daysPassed);
      console.log('cdays daysLeft: ', cdays.daysLeft);

      this.setState({
        //totalLc: data.totalLc,
        MEVav: data.MEVav,
        WALLETCInUSD: data.WALLETCInUSD,
        totalGif: data.totalGif,
        totalBNB: data.totalBNB,
        bnbPrice: data.bnbPrice,
        gif30: data.rlcProj,
        TOTpledge: data.TOTpledge,
        dayLim: data.LcLim,
        loading: false,
        daysPassed: cdays.daysPassed,
        daysLeft: cdays.daysLeft,
        totalBNBInUSD: data.totalBNBInUSD,
        MEVprice: data.MEVprice
      });
    } catch (err) {
      console.error('Failed to load totals:', err);
      let errorMsg = 'Failed to load totals';
      if (err.message.includes('coingecko')) {
        errorMsg = 'Failed to fetch BNB price from CoinGecko — using fallback price of $600';
      }
      this.setState({ 
        error: errorMsg, 
        loading: false 
      });
      // Still try to show partial data if available
    }
  }
getPatreonTotals = async () => {
  const db = firebase.database;

  // Fetch MEVinfo values (now including BNB_PRICE_IN_USD)
  const patreonRef = db.ref('patreon');
  const pSnapshot = await patreonRef.once('value');
  const pData = pSnapshot.val() || {};

  const LcLim = Number(pData.limit) || 0;
  return LcLim;
 
}

getTotals = async () => {
  const db = firebase.database;
  const LcLim = await this.getPatreonTotals();
  console.log('getTotals 1z', LcLim);
  const rLcLim = LcLim / 100;
  const rlcProj = rLcLim * 30;

  // Fetch MEVinfo values (now including BNB_PRICE_IN_USD)
  const mevInfoRef = db.ref('MEVinfo');
  const mevInfoSnapshot = await mevInfoRef.once('value');
  const mevInfoData = mevInfoSnapshot.val() || {};

  const totalBNB = Number(mevInfoData.WALLETA) || 0;
  const MEVav    = Number(mevInfoData.MEVav)    || 0;
  const walletC  = Number(mevInfoData.WALLETC)  || 0;
  const TOTpledge = Number(mevInfoData.TOTpledge)  || 0;
  const MEVprice = Number(mevInfoData.MEVprice)  || 0;

  // Read BNB price from Firebase
  let bnbPrice = Number(mevInfoData.BNB_PRICE_IN_USD) || 900; // fallback if missing/invalid

  if (isNaN(bnbPrice) || bnbPrice <= 0) {
    console.warn('Invalid or missing BNB_PRICE_IN_USD in Firebase — using fallback 600');
    bnbPrice = 600;
  }

  const totalBNBInUSD = totalBNB * bnbPrice;
  const WALLETCInUSD  = walletC  * bnbPrice;

  console.log('getTotalsT bnbPrice:', bnbPrice);
  console.log('getTotalsT totalBNB:', totalBNB);
  console.log('getTotalsT totalBNBInUSD:', totalBNBInUSD);

  console.log('getTotals 1d');

  // Fetch users and calculate totalLc (unchanged)
  const usersRef = db.ref('user');
  const usersSnapshot = await usersRef.once('value');
  console.log('getTotals 1e');

  let totalPoints = 0;
  let ttpoints = 0;
  const execMembers = [];

  usersSnapshot.forEach((childSnapshot) => {
    const user = childSnapshot.val();
    if (user?.execmember === true) {
      const points = Number(user.points);
    //  console.log('userLcLog: ', user.email + ' - ' + user.companyName + ' - ' + user.points / 100);

      if (!isNaN(points)) totalPoints += points;
    }
  });
  this.setState({ execMembers, loading: false });
  console.log('userLcLog tot: ', ttpoints);

  const totalLc = totalPoints / 100; //tot Lc in system
  const totalGif = totalBNBInUSD - totalLc;

  console.log('getTotals 1', totalGif);
  console.log('getTotals 2', totalLc);
  console.log('getTotals 3', MEVav);
  console.log('getTotals 4', WALLETCInUSD);
  console.log('getTotals 5', TOTpledge);

  return { 
    totalLc, 
    MEVav, 
    WALLETCInUSD, 
    totalGif,
    bnbPrice,  // optional: expose if you want to display it
    rlcProj,
    TOTpledge,
    totalBNB,
    LcLim,
    totalBNBInUSD,
    MEVprice
  };
};

getMonthProgress = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = now.getMonth(); // 0-based (0 = January)

  // Total days in this month
  const totalDaysInMonth = new Date(year, month + 1, 0).getDate();

  // Days passed (including today)
  const daysPassed = now.getDate();

  // Days left (excluding today)
  const daysLeft = totalDaysInMonth - daysPassed;

  return {
    daysPassed,
    daysLeft
  };
};

fetchData = async () => {
  this.setState({ loading: true });

  const formatDate = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0);
  const endDate   = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);

  const startStr = formatDate(startDate);
  const endStr   = formatDate(endDate);

  const dbRef = firebase.database
    .ref('MEVDATA')
    .orderByChild('fdate')
    .startAt(startStr)
    .endAt(endStr);

  try {
    const snapshot = await dbRef.once('value');
    const rawData = snapshot.val();

    if (!rawData) {
      this.setState({ lcOut: 0, MEVbuy: 0, MEVsold: 0, loading: false });
      return;
    }

    const filtered = Object.values(rawData).filter(item =>
      item.fdate &&
      !isNaN(new Date(item.fdate).getTime()) &&
      !item.fdate.startsWith('2026-02-17')
    );

    let lcInTotal = 0;
    let tokensTot = 0;
    let mevBuyTotal = 0;
    let mevSoldTotal = 0;
    let lcOutTotal = 0;   // ← this is now calculated directly as positive amount going out
    let TokensBuy = 0;
    let TokensSpent = 0;
    let Lcfallback = 0;

    const lcInTypes = [
      'Super Pledge confirmed',
      'Flex Pledge confirmed',
      'Pledge confirmed',
      'Lc earned from Pledge',
      'GIF Pledge confirmed',
    ];

    const parsePoints = (val) => {
      if (val == null) return 0;
      const cleaned = String(val).replace(/[^0-9.-]/g, '');
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : Math.abs(num);   // absolute value so "spent" is always positive
    };
     let iTOTgif = 0;
     let itotalLc = 0;

    filtered.forEach(item => {
      const type = (item.actionType || 'Unknown').trim();
      const points = parsePoints(item.pointsAdded);   // always positive
      const tokens = parsePoints(item.tokensAdded);   // always positive

      if (lcInTypes.includes(type)) {
        lcInTotal += points;
        //tokensTot += tokens;
        console.log('gifstats lcInTotal 1: ', type);
        console.log('gifstats lcInTotal 2: ', points);
        //There are 2 types
        // 1. Lc to user & Lc to GIF -  all lcInTypes except 'GIF Pledge confirmed'
        // 2. Lc to GIF only - 'GIF Pledge confirmed'

        if (type==='GIF Pledge confirmed') { //just GIF
          iTOTgif = iTOTgif + (3 * points);
        }
        else
        {
          iTOTgif = iTOTgif + (2 * points);
          itotalLc = itotalLc + points;
        }
    // MORE CATEGORIES TO ADD
    // Agent token deduction
    // Agent cost subtraction
    // Tokens purchased

      } else if (type === 'MEV buy') {
        mevBuyTotal += points;
      } else if (type === 'MEV sold') {
        mevSoldTotal += points;
      } else if (type === 'Tokens purchased') {
        TokensBuy += tokens;
      } else if (type === 'Agent token deduction') {
        TokensSpent += tokens;
      } else if (type === 'Agent Lc fallback') {
        Lcfallback += points;
        // console.log('Lc deducted from ', item.firstName);
        // console.log('Lc deducted from trailID ', item.trailID);
        // console.log('Lc deducted from Lc ', item.pointsAdded);
      } else {
        // EVERYTHING ELSE (Lc sent, received, Like given, Test Passed, AI Test Published..., Comment received, post deleted, etc.)
        lcOutTotal += points;
      }
    });

    console.log('gifStats FINAL TOTALS →', {
      lcIn: lcInTotal.toFixed(4),
      lcOut: lcOutTotal.toFixed(4),
      MEVbuy: mevBuyTotal.toFixed(4),
      MEVsold: mevSoldTotal.toFixed(4),
      Lcfallback: Lcfallback.toFixed(4)
    });

    this.setState({
      lcOut: lcOutTotal, //all Lc moved from GIF to user accounts through utilties
      MEVbuy: mevBuyTotal,
      MEVsold: mevSoldTotal,
      TOTgif: iTOTgif, //all Lc from pledges allocated to GIF
      totalLc: itotalLc, //all Lc from pledges allocated to user accounts
      TokensBuy: TokensBuy,
      TokensSpent: TokensSpent,
      Lcfallback: Lcfallback,
      loading: false
    });

  } catch (err) {
    console.error('MEVDATA fetch error:', err);
    this.setState({ lcOut: 0, MEVbuy: 0, MEVsold: 0, loading: false });
  }
};

fetchData_Mar30 = async () => {
  // Prevent double execution (common in React dev mode)
  console.log('gifStats fetchData: 0');
  this.setState({ 
     loading: true, 
      lcOut: 0, 
      MEVbuy: 0, 
      MEVsold: 0,
    });

 // if (this.state.loading) return;

  // ONLY set loading (no lcOut: 0 here → no flash to zero)
console.log('gifStats fetchData: 1');

  // Format dates to EXACTLY match Firebase
  const formatDate = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };
console.log('gifStats fetchData: 2');
  // First day of current month 00:00 → today 23:59
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0);
  const endDate   = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);

  const startStr = formatDate(startDate);
  const endStr   = formatDate(endDate);
console.log('gifStats fetchData: 3');
  // Build query
  const dbRef = firebase.database
    .ref('MEVDATA')
    .orderByChild('fdate')
    .startAt(startStr)
    .endAt(endStr);

  try {
    const snapshot = await dbRef.once('value');   // ← proper await
    const rawData = snapshot.val();
console.log('gifStats fetchData: 4');
    if (!rawData) {
      this.setState({ lcOut: 0, MEVbuy: 0, MEVsold: 0, loading: false });
      return;
    }
console.log('gifStats fetchData: 5');
    // Safety filter + exclude 2026-02-17 (remove this line if you no longer need it)
    const filtered = Object.values(rawData).filter(item => {
      return item.fdate 
        && !isNaN(new Date(item.fdate).getTime())
        && !item.fdate.startsWith('2026-02-17');
    });
console.log('gifStats fetchData: 6');
    let totalPoints = 0;
    let excludedPoints = 0;
    let mevBuyTotal = 0;   // NEW
    let mevSoldTotal = 0;  // NEW

  //  const pledgeTypes = ['Super Pledge confirmed', 'Flex Pledge confirmed', 'Pledge confirmed'];
    const pledgeTypes = ['Super Pledge confirmed', 'Flex Pledge confirmed', 'Pledge confirmed'];

    const parsePoints = (val) => {
      if (val == null) return 0;
      const cleaned = String(val).replace(/[^0-9.-]/g, '');
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    };
console.log('gifStats fetchData: 7');
    filtered.forEach(item => {
      const type = item.actionType || 'Unknown';
      const points = parsePoints(item.pointsAdded);

      totalPoints += points;

      // MEV totals (exactly as you asked)
      if (type === 'MEV buy') {
        mevBuyTotal += points;
      } else if (type === 'MEV sold') {
        mevSoldTotal += points;
      }
console.log('gifStats fetchData: 8');
      // Everything that was previously excluded for lcOut
      if (pledgeTypes.includes(type) || type === 'MEV buy' || type === 'MEV sold') {
        excludedPoints += points;
      }
    });
console.log('gifStats fetchData: 9');
    const lcOutTotal = totalPoints - excludedPoints;

    // === EXACTLY as you requested ===
    this.setState({ 
      lcOut: lcOutTotal, 
      MEVbuy: mevBuyTotal, 
      MEVsold: mevSoldTotal, 
      loading: false 
    });
console.log('gifStats fetchData: 10', mevBuyTotal);

  } catch (err) {
    console.error('MEVDATA fetch error:', err);
    this.setState({ lcOut: 0, MEVbuy: 0, MEVsold: 0, loading: false });
  }
};

fetchData_default = async() => {
  // Reset lcOut to 0 immediately → no more "null" flash while loading
  this.setState({ loading: true, lcOut: 0 });

  // Format dates to EXACTLY match what is stored in your Firebase (YYYY-MM-DD HH:mm)
  const formatDate = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  // First day of current month 00:00 → today 23:59 (matches DB format)
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0);
  const endDate   = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);

  const startStr = formatDate(startDate);
  const endStr   = formatDate(endDate);

  // Build query
  const dbRef = firebase.database
    .ref('MEVDATA')
    .orderByChild('fdate')
    .startAt(startStr)
    .endAt(endStr);

  await dbRef.once('value', (snapshot) => {
    const rawData = snapshot.val();

    if (!rawData) {
      this.setState({ lcOut: 0, loading: false });
      return;
    }

    // Safety filter
    const filtered = Object.values(rawData).filter(item => {
      return item.fdate && !isNaN(new Date(item.fdate).getTime());
    });

    let totalPoints = 0;
    let excludedPoints = 0;

    const pledgeTypes = ['Super Pledge confirmed', 'Flex Pledge confirmed', 'Pledge confirmed'];
    const mevTypes = ['MEV buy', 'MEV sold'];

    // Local parser (safe replacement for the old this.parsePoints)
    const parsePoints = (val) => {
      if (val == null) return 0;
      const cleaned = String(val).replace(/[^0-9.-]/g, '');
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    };

    filtered.forEach(item => {
      const type = item.actionType || 'Unknown';
      const points = parsePoints(item.pointsAdded);

      totalPoints += points;

      if (pledgeTypes.includes(type) || mevTypes.includes(type)) {
        excludedPoints += points;
      }
    });

    const lcOutTotal = totalPoints - excludedPoints;

    this.setState({ lcOut: lcOutTotal, loading: false });
  }).catch(err => {
    console.error('MEVDATA fetch error:', err);
    this.setState({ lcOut: 0, loading: false });
  });
};

fetchData_exclude17Feb = async () => {
  // Only set loading — DO NOT reset lcOut to 0 here
  // This prevents the "0 flash" (old value stays visible until real data arrives)
  this.setState({ loading: true });

  // Format dates to exactly match Firebase (YYYY-MM-DD HH:mm)
  const formatDate = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  // First day of current month 00:00 → today 23:59
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0);
  const endDate   = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);

  const startStr = formatDate(startDate);
  const endStr   = formatDate(endDate);

  // Build query
  const dbRef = firebase.database
    .ref('MEVDATA')
    .orderByChild('fdate')
    .startAt(startStr)
    .endAt(endStr);

  try {
    // Proper await (this was the broken part in your version)
    const snapshot = await dbRef.once('value');
    const rawData = snapshot.val();

    if (!rawData) {
      this.setState({ lcOut: 0, loading: false });
      return;
    }

    // Exclude 2026-02-17 (unchanged)
    const filtered = Object.values(rawData).filter(item => {
      return item.fdate 
        && !isNaN(new Date(item.fdate).getTime())
        && !item.fdate.startsWith('2026-02-17');
    });

    let totalPoints = 0;
    let excludedPoints = 0;

    const pledgeTypes = ['Super Pledge confirmed', 'Flex Pledge confirmed', 'Pledge confirmed'];
    const mevTypes = ['MEV buy', 'MEV sold'];

    const parsePoints = (val) => {
      if (val == null) return 0;
      const cleaned = String(val).replace(/[^0-9.-]/g, '');
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    };

    filtered.forEach(item => {
      const type = item.actionType || 'Unknown';
      const points = parsePoints(item.pointsAdded);

      totalPoints += points;

      if (pledgeTypes.includes(type) || mevTypes.includes(type)) {
        excludedPoints += points;
      }
    });

    const lcOutTotal = totalPoints - excludedPoints;

    this.setState({ lcOut: lcOutTotal, loading: false });

  } catch (err) {
    console.error('MEVDATA fetch error:', err);
    this.setState({ lcOut: 0, loading: false });
  }
};

// fetchData = () => { //proper full function
//   // Reset lcOut to 0 immediately → no more "null" flash while loading
//   this.setState({ loading: true, lcOut: 0 });
// console.log('gifStats fetchData 1:');
//   // Format dates to EXACTLY match what is stored in your Firebase (YYYY-MM-DD HH:mm)
//   const formatDate = (date) => {
//     const pad = (n) => String(n).padStart(2, '0');
//     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
//   };
// console.log('gifStats fetchData 2:');

//   // First day of current month 00:00 → today 23:59 (matches DB format)
//   const now = new Date();
//   const startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0);
//   const endDate   = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);

//   const startStr = formatDate(startDate);
//   const endStr   = formatDate(endDate);
// console.log('gifStats fetchData 3:');

//   // Build query
//   const dbRef = firebase.database
//     .ref('MEVDATA')
//     .orderByChild('fdate')
//     .startAt(startStr)
//     .endAt(endStr);
// console.log('gifStats fetchData 4:');
//   dbRef.once('value', (snapshot) => {
//     const rawData = snapshot.val();
// console.log('gifStats fetchData 5:');
//     if (!rawData) {
//       this.setState({ lcOut: 0, loading: false });
//       return;
//     }
// console.log('gifStats fetchData 6:');
//     // Safety filter
//     const filtered = Object.values(rawData).filter(item => {
//       return item.fdate && !isNaN(new Date(item.fdate).getTime());
//     });

//     let totalPoints = 0;
//     let excludedPoints = 0;
// console.log('gifStats fetchData 7:');
//     const pledgeTypes = ['Super Pledge confirmed', 'Flex Pledge confirmed', 'Pledge confirmed'];
//     const mevTypes = ['MEV buy', 'MEV sold'];
// console.log('gifStats fetchData 8:');
//     // Local parser (safe replacement for the old this.parsePoints)
//     const parsePoints = (val) => {
//       if (val == null) return 0;
//       const cleaned = String(val).replace(/[^0-9.-]/g, '');
//       const num = parseFloat(cleaned);
//       return isNaN(num) ? 0 : num;
//     };
// console.log('gifStats fetchData 9:');
//     filtered.forEach(item => {
//       const type = item.actionType || 'Unknown';
//       const points = parsePoints(item.pointsAdded);

//       totalPoints += points;
// console.log('gifStats fetchData 10:');
//       if (pledgeTypes.includes(type) || mevTypes.includes(type)) {
//         excludedPoints += points;
//       }
//     });

//     const lcOutTotal = totalPoints - excludedPoints;
// console.log('gifStats fetchData 11:', lcOutTotal);

//     this.setState({ lcOut: lcOutTotal, loading: false });
//   }).catch(err => {
//     console.error('MEVDATA fetch error:', err);
//     this.setState({ lcOut: 0, loading: false });
//   });
// };

calculateProjections = () => {
  const { MEVav = 0, WALLETCInUSD = 0, appliedCustomPrice } = this.state; // default to 0

  let price = appliedCustomPrice !== null ? appliedCustomPrice : (WALLETCInUSD / MEVav || 0);

  if (MEVav <= 0) {
    console.warn('No valid MEVav → impact table skipped');
    return {
      price: 0,
      maxSafeSell: 0,
      liquidityTable: [],
      impactTable: []
    };
  }

  const maxImpact = 0.01;
  const rMax = maxImpact / (2 - maxImpact);
  const maxSafeSell = rMax * MEVav;

  // Required liquidity table (unchanged)
  const sellAmounts = [100, 200, 300, 400, 500, 750, 1000];
  const liquidityTable = sellAmounts.map((x) => {
    const requiredMEVav = x / rMax;
    const requiredUSD   = requiredMEVav * price;
    return { x, requiredMEVav: Math.round(requiredMEVav), requiredUSD: Math.round(requiredUSD) };
  });

  // Impact table — add safety check
  const impactAmounts = [10, 25, 50, 75, 100, 150, 200];
  const impactTable = impactAmounts.map((x) => {
    const r = x / MEVav;
    const impactPct = (2 * r) / (1 + r) * 100;
    return { x, impact: isFinite(impactPct) ? impactPct.toFixed(2) : '—' };
  });

  console.log('Generated impactTable:', impactTable); // ← helpful

  return { price, maxSafeSell, liquidityTable, impactTable };
};

  // ASCII graph (unchanged)
  renderAsciiImpactGraph = (impactTable) => {
    if (!impactTable.length) return null;
    const maxImpact = Math.max(...impactTable.map(row => parseFloat(row.impact)));
    const height = 10;
    let lines = [];

    for (let y = height; y >= 0; y--) {
      let line = '';
      impactTable.forEach(({ x, impact }) => {
        const barHeight = Math.round((parseFloat(impact) / maxImpact) * height);
        line += barHeight >= y ? '█' : ' ';
        line += '  ';
      });
      lines.push(line);
    }

    const xLabels = impactTable.map(({ x }) => x.toString().padStart(3)).join('  ');
    return (
      <pre style={{ fontSize: '12px', lineHeight: '1.1', margin: '10px 0' }}>
        {lines.join('\n')}
        {'─'.repeat(xLabels.length)}
        {'\n'}{xLabels}
        {'\nSell amount (MEV) →'}
      </pre>
    );
  };

  // Handle custom price input
  handleCustomPriceChange = (e) => {
    const value = e.target.value;
    if (value === '' || (!isNaN(value) && Number(value) >= 0)) {
      this.setState({ customMeVPrice: value });
    }
  };

  applyCustomPrice = () => {
    const value = this.state.customMeVPrice.trim();
    if (value !== '' && !isNaN(value)) {
      this.setState({ appliedCustomPrice: Number(value) });
    } else {
      this.setState({ appliedCustomPrice: null }); // reset to live price
    }
  };

  render() {
    const { 
      totalLc, totalGif, MEVav, WALLETCInUSD, bnbPrice, 
      loading, error, customMeVPrice, gif30, TOTpledge, totalBNB, dayLim, totalBNBInUSD,
      daysPassed, daysLeft, lcOut, MEVprice, MEVbuy, MEVsold, TokensBuy, TokensSpent, Lcfallback, TOTgif
    } = this.state;

    if (loading) return <div>Loading totals from Firebase...</div>;
    // if (loadingb) {
    //   return <div>Loading executive members...</div>;
    // }

    // if (error) {
    //   return <div>Error: {error}</div>;
    // }

    // if (execMembers.length === 0) {
    //   return <div>No executive members found.</div>;
    // }

    const {
      price,
      maxSafeSell,
      liquidityTable,
      impactTable
    } = this.calculateProjections();
     const TOTpledgeLc = TOTpledge / 100;

    // lcOut:  //all Lc moved from GIF to user accounts through utilties
    // TOTgif: //all Lc from pledges allocated to GIF
    // totalLc: //all Lc from pledges allocated to user accounts

     const WALLETCInBNB = WALLETCInUSD / bnbPrice;
     const dayLimLc = dayLim / 100;    

     const TOTspent = lcOut;
     const Lcleft = TOTgif - TOTspent //whats left in TOTAL GIF
     const real_GIF = dayLimLc * daysLeft; //whats left for users in GIF
     const lefover = Lcleft - TOTpledgeLc; //Everything left - Total pledge req
     const dailyBudgetMax = Lcleft / daysLeft;
     const MEVboughtLc = MEVbuy * MEVprice;
     const totLctoUsers = lcOut + totalLc;
     //accPledges = totalBNBInUSD - (Lc-currently-in-useraccounts + Lc-in-GIF-now)
     //Lc-currently-in-useraccounts = (used Lc + all Lc to user from pledges) - Lc-spent-for-MEV
     let Lc_currently_in_useracc = (lcOut + totalLc) - MEVboughtLc;

     const accPledges = totalBNBInUSD - Lc_currently_in_useracc - real_GIF; //inWallet - all Lc in userwallets - whats left in GIF

     console.log('gaccPledges accPledges: ', accPledges);
     console.log('gaccPledges totalBNBInUSD: ', totalBNBInUSD);
     console.log('gaccPledges totalLc: ', totalLc);
     console.log('gaccPledges real_GIF: ', real_GIF);
     console.log('gaccPledges TOTgif: ', TOTgif);

     const GIFmir = totalLc + Lcleft; 
    // const TodoGoal = GIFmir + TOTpledgeLc;
     const accPledgeNeeded = TOTpledgeLc - accPledges;

     const MEVbought = MEVbuy;
     const TokensBought = TokensBuy;
     //const TokensSpent = TokensSpent;
     const MEVsales = MEVsold;

     //const sendToLiq = accPledges - accPledgeNeeded;

     let showLiqSend;
     if (accPledgeNeeded < 0) {
       showLiqSend = 0 -(accPledgeNeeded);
     }
     else{
       showLiqSend = 0;
     }

    // const MEVsalesLc = MEVsold * MEVprice;

     console.log('gifStats MEVbought: ', MEVbought);
     console.log('gifStats MEVboughtLc: ', MEVboughtLc);
     console.log('gifStats MEVsales: ', MEVsales);

     //Total Lc earned vs GIF vs TOT Lc in accounts + Lc left in GIF
     console.log('gifStats TOTspent: ', TOTspent);
     console.log('gifStats TOTgif: ', TOTgif);
     console.log('gifStats GIFmir: ', GIFmir);

     //Lc used to buy MEV vs Lc left in GIF vs Lc in accounts
     console.log('gifStats Lc for MEV: ', MEVboughtLc);
     console.log('gifStats Lcleft in GIF: ', Lcleft);
     console.log('gifStats totalLc in accounts: ', totalLc);

     // curr day limit vs max daily budget
     console.log('gifStats day limit: ', dayLimLc);
     console.log('gifStats dailyBudgetMax: ', dailyBudgetMax);

     //Pledges accumilation vs total bulk pledge requirement vs total inwallet in Lc
     console.log('gifStats accPledges: ', accPledges);
     console.log('gifStats totBNBpledge: ', TOTpledgeLc);
     console.log('gifStats totalBNBInUSD: ', totalBNBInUSD);
     console.log('gifStats Leftover: ', lefover);

    return (
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
        <h2>System Totals & MEV Sell Projections</h2>

        {error && (
          <div style={{ color: 'orange', marginBottom: '16px' }}>
            {error}
            <br />
            <small>(Some values may use fallback data)</small>
          </div>
        )}

        <div style={{ marginBottom: '24px' }}>
          <strong>Current MEV Price (live):</strong> ${ MEVprice.toFixed(4) } USD 
          {bnbPrice && <span> (BNB @ ${bnbPrice.toFixed(2)})</span>}
          <br />
          <strong>Projection Price in use:</strong> ${price.toFixed(4)} USD
          <br />
          <strong>Max safe sell per user/month (≤1% impact):</strong> {maxSafeSell.toFixed(2)} MEV
        </div>

       <h3>Live Values</h3>
          <div>
            <FiveBarHistogram
              cat1="Total Lc earned"
              val1={TOTspent}
              cat2="Lc in GIF from Pledges"
              val2={TOTgif}
              cat3="Lc in user GIF"
              val3={real_GIF}
              cat4="Lc used to buy MEV"
              val4={MEVboughtLc}
              cat5="Lc to settle Agent Cost"
              val5={Lcfallback}
            />
          </div>

          <div>
            <FiveBarHistogram
              cat1="Total Lc to users"
              val1={totLctoUsers}
              cat3="Lc spent on MEV"
              val3={MEVboughtLc}           
            />
          </div>

          <div>
            <FiveBarHistogram
              cat1="MEV Bought"
              val1={MEVbought}
              cat2="MEV Sold"
              val2={MEVsales}
              cat3="Tokens Bought"
              val3={TokensBought}   
              cat4="Tokens Spent"
              val4={TokensSpent}                 
            />
          </div>

          <div>
            <FiveBarHistogram
              cat1="curr day limit"
              val1={dayLimLc}
              cat2="max daily budget"
              val2={dailyBudgetMax}
            />
          </div>

          <div>
            <FiveBarHistogram
              cat1="Pledges accumilation"
              val1={accPledges}
              cat2="total pledge req."
              val2={TOTpledgeLc}
              cat3="total inwallet in Lc"
              val3={totalBNBInUSD}
              cat4="Pledge Short"
              val4={accPledgeNeeded}
              cat5="Send to Liquidity"
              val5={showLiqSend}
            />
          </div>

        {/* Live Values */}
         <h3>Live Values</h3>
        <div>
          <div><b>GIF</b> </div>  
          <div>Curr day limit: {dayLimLc?.toFixed(2) ?? '—'} Lc</div>  
          {/* <div>Max daily budget: {dailyBudgetMax?.toFixed(2) ?? '—'} Lc</div>   */}
          <div>GIF Now(users): {real_GIF?.toFixed(2) ?? '—'} Lc</div>  
          <div>  &nbsp;  </div> 
          <div><b>Pledges</b> </div>  
          <div>Pledges accumilation: {accPledges?.toFixed(2) ?? '—'} Lc</div>  
          <div>Total pledge requirement : {TOTpledgeLc?.toFixed(2) ?? '—'} Lc</div>  
          <div>Total inwallet: {totalBNBInUSD?.toFixed(2) ?? '—'} Lc</div>  
          <div>Pledge short: {accPledgeNeeded?.toFixed(2) ?? '—'} Lc</div>  
          <div>Lc Send to Liquidity: {showLiqSend?.toFixed(2) ?? '—'} Lc</div> 
         <div>  &nbsp;  </div> 
         <div><b>MEV </b> </div>  
          <div>MEV bought this month: {MEVbought?.toFixed(2) ?? '—'} MEV</div>  
          <div>MEV sold this month: {MEVsales?.toFixed(2) ?? '—'} MEV</div>  
          <div>Tokens bought this month: {TokensBought?.toFixed(2) ?? '—'} Tokens</div> 
          <div>Tokens spent this month: {TokensSpent?.toFixed(2) ?? '—'} Tokens</div> 
          <div>Total MEV in liq: {MEVav?.toFixed(2) ?? '—'} MEV</div>  
          <div>  &nbsp;  </div>  
         <div><b>Liquidity </b> </div>  
          <div>Liquidity in Lc: {WALLETCInUSD?.toFixed(2) ?? '—'} Lc</div>  
          <div>Liquidity in BNB: {WALLETCInBNB?.toFixed(2) ?? '—'} BNB</div>  
          <div>  &nbsp;  </div> 
        </div>
        {isMobile ? 
         <div>
         {/* <h3>Live Values</h3>

          <div>Total Lc: {totalLc?.toFixed(2) ?? '—'} Lc</div>
          <div>Total GIF: {totalGif?.toFixed(2) ?? '—'} Lc</div>
          <div>Wallet C: {WALLETCInUSD?.toLocaleString(undefined, { minimumFractionDigits: 2 })} USD</div>      
          <div>InWALLET current(BNB): {totalBNB ?? '—'} BNB</div>
          <div>INWALLET 30 days(BNB): {GIFinBNB ?? '—'} BNB</div>
          <div>Total Pledge: {TOTpledgeLc ?? '—'} Lc</div>
          <div>GIF from Pledge: {(TOTpledgeLc / 2) ?? '—'} Lc</div>
          <div>GIF 30 Days: {gif30 ?? '—'} Lc</div>
          <div>GIF core 30 Days: {GIFcore ?? '—'} BNB</div>
          <div>BNB to cover pledges: {totBNBpledge ?? '—'} BNB</div>  
          <div>GIF from pledges in BNB: {totBNBgif ?? '—'} BNB</div> 
          <div>GIF 30 Days in BNB: {gif30BNB ?? '—'} BNB</div> 
          <div>BNB for MEV purchase & pledge: {NOWgifBNB ?? '—'} BNB</div>   
          <div>MEV coins: {MEVav?.toLocaleString() ?? '—'} MEV</div> */}
        </div>     
        : 
       <div>
      {/*  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px', marginBottom: '32px' }}>    */}
    {/*    <div>Total Lc: {totalLc?.toFixed(2) ?? '—'} Lc</div>      Total Lc held by users     */}
       {/*     <div>Total GIF: {totalGif?.toFixed(2) ?? '—'} Lc</div>        Total Lc in inwallet minus Lc held by users (in Lc) */}
        {/*  <div>Wallet C: {WALLETCInUSD?.toLocaleString(undefined, { minimumFractionDigits: 2 })} USD</div>     tot liquidity in Lc */}  
        {/*  <div>InWALLET current(BNB): {totalBNB ?? '—'} BNB</div>    Total BNB in inwallet */}  
        {/*  <div>INWALLET 30 days(BNB): {GIFinBNB ?? '—'} BNB</div>     All BNB that will be used in 30 days by inwallet */}  
        {/*  <div>Total Pledge: {TOTpledgeLc ?? '—'} Lc</div>       Total mass pledge in Lc */}
        {/*  <div>GIF from Pledge: {(TOTpledgeLc / 2) ?? '—'} Lc</div>    Total GIF derived 50% from mass pledge */}
        {/*  <div>GIF 30 Days: {gif30 ?? '—'} Lc</div>      Max Lc spent in 30 days from GIF */}
        {/*  <div>GIF core 30 Days: {GIFcore ?? '—'} BNB</div>       BNB needed to cover GIF 30 days + Lc spent to buy MEV  */}
        {/*  <div>BNB to cover pledges: {totBNBpledge ?? '—'} BNB</div>       BNB needed to cover Total mass pledge */}
        {/*  <div>GIF from pledges in BNB: {totBNBgif ?? '—'} BNB</div>       GIF from mass pledge in BNB*/}
        {/*  <div>GIF 30 Days in BNB: {gif30BNB ?? '—'} BNB</div>       BNB needed to cover 30 days GIF  */}       
        {/*  <div>BNB for MEV purchase & pledge: {NOWgifBNB ?? '—'} BNB</div>       BNB needed to cover MEV purchases & pledge */}       
        {/*  <div>MEV coins: {MEVav?.toLocaleString() ?? '—'} MEV</div>       Total MEV in liqudity */}
       {/* </div>   */}
         </div>  
        }
   
        {/* Custom Price Input + Required Liquidity Table */}
        <h3>Required Liquidity for 1% Max Price Impact</h3>

        <Grid container spacing={2} alignItems="center" style={{ marginBottom: '16px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Custom MEV Price (USD)"
              variant="outlined"
              size="small"
              type="number"
              value={customMeVPrice}
              onChange={this.handleCustomPriceChange}
              placeholder="e.g. 10"
              helperText="Leave blank to use live price"
            />
          </Grid>
          <Grid item>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={this.applyCustomPrice}
              disabled={!customMeVPrice && customMeVPrice !== '0'}
            >
              Apply Price
            </Button>
          </Grid>
        </Grid>

        <table style={{ borderCollapse: 'collapse', width: '100%', marginBottom: '32px' }}>
          <thead>
            <tr style={{ background: '#f0f0f0' }}>
              <th style={{ padding: '8px', border: '1px solid #ddd' }}>Max Sell (MEV)</th>
              <th style={{ padding: '8px', border: '1px solid #ddd' }}>Required MEVav</th>
              <th style={{ padding: '8px', border: '1px solid #ddd' }}>Required Liquidity (USD)</th>
            </tr>
          </thead>
          <tbody>
            {liquidityTable.map((row, i) => (
              <tr key={i}>
                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.x}</td>
                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.requiredMEVav.toLocaleString()}</td>
                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>${row.requiredUSD.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>

<h3>Price Impact % at Current Liquidity</h3>

{MEVav > 0 ? (
  <>
    <table style={{ borderCollapse: 'collapse', width: '60%', marginBottom: '16px' }}>
      <thead>
        <tr style={{ background: '#f0f0f0' }}>
          <th style={{ padding: '8px', border: '1px solid #ddd' }}>Sell Amount (MEV)</th>
          <th style={{ padding: '8px', border: '1px solid #ddd' }}>Price Impact (%)</th>
        </tr>
      </thead>
      <tbody>
        {impactTable.length > 0 ? (
          impactTable.map((row, i) => (
            <tr key={i}>
              <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.x}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                {row.impact}%
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={2} style={{ padding: '12px', textAlign: 'center' }}>
              No impact data available (MEVav = {MEVav})
            </td>
          </tr>
        )}
      </tbody>
    </table>

    <h4>Impact Curve (Current Pool)</h4>
    {impactTable.length > 0 ? (
      this.renderAsciiImpactGraph(impactTable)
    ) : (
      <pre>No graph available (insufficient pool data)</pre>
    )}
  </>
) : (
  <p style={{ color: '#888' }}>
    Current liquidity pool size (MEVav) is not available or zero — impact calculations skipped.
  </p>
)}
        <p style={{ fontSize: '0.9em', color: '#666', marginTop: '32px' }}>
          Projections use linear impact model. 1% max price impact threshold. Custom price overrides live calculation.
        </p>
      </div>
    );
  }
}

export default TotalsDashboard;
// ///////////////////////////////////////////////////////////////////////////////////////////
// import React, { Component } from 'react';
// import firebase from '../../store/firebase';

// class TotalsDashboard extends Component {
//   state = {
//     totalLc: null,
//     totalGif: null,
//     MEVav: null,
//     WALLETCInUSD: null,
//     loading: true,
//     error: null,
//   };

//   async componentDidMount() {
//     try {
//       const { totalLc, MEVav, WALLETCInUSD, totalGif } = await this.getTotals();
//      console.log('getTotals 0'); 
//       this.setState({
//         totalLc,
//         MEVav,
//         WALLETCInUSD,
//         totalGif,
//         loading: false,
//       });
//     } catch (err) {
//       console.error(err);
//       this.setState({ error: 'Failed to load totals', loading: false });
//     }
//   }

//   getTotals = async () => {
//     const db = firebase.database;
// console.log('getTotals 1z');
//     const mevInfoRef = db.ref('MEVinfo');
//     const mevInfoSnapshot = await mevInfoRef.once('value');
//     const mevInfoData = mevInfoSnapshot.val() || {};
//  console.log('getTotals 1a');
//     const totalBNB = Number(mevInfoData.WALLETA) || 0;
//     const MEVav = Number(mevInfoData.MEVav) || 0;
//     const walletC = Number(mevInfoData.WALLETC) || 0;
//  console.log('getTotals 1b');
//     const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd');
//     const data = await response.json();
//     const bnbPrice = data?.binancecoin?.usd || 0;
//  console.log('getTotals 1c');
//     const totalBNBInUSD = totalBNB * bnbPrice;
//     const WALLETCInUSD = walletC * bnbPrice;
// console.log('getTotals 1d');
//     const usersRef = db.ref('user');
//     const usersSnapshot = await usersRef.once('value');
// console.log('getTotals 1e');
//     let totalPoints = 0;
//     usersSnapshot.forEach((childSnapshot) => {
//       const user = childSnapshot.val();
//       if (user?.execmember === true) {
//         const points = Number(user.points);
//         if (!isNaN(points)) totalPoints += points;
//       }
//     });

//     const totalLc = totalPoints / 100;
//     const totalGif = totalBNBInUSD - totalLc;
//     console.log('getTotals 1', totalGif);
//     console.log('getTotals 2', totalLc);    
//     console.log('getTotals 3', MEVav);
//     console.log('getTotals 4', WALLETCInUSD);

//     return { totalLc, MEVav, WALLETCInUSD, totalGif };
//   };

//   // ────────────────────────────────────────────────
//   // Projection helpers (using live data)
//   // ────────────────────────────────────────────────

//   calculateProjections = () => {
//     const { MEVav, WALLETCInUSD } = this.state;

//     if (!MEVav || !WALLETCInUSD || MEVav <= 0) {
//       return { price: 0, maxSafeSell: 0, impactTable: [], liquidityTable: [] };
//     }

//     const price = WALLETCInUSD / MEVav;
//     console.log('getTotals 6');
//     // For 1% max price impact
//     const maxImpact = 0.01;
//     const rMax = maxImpact / (2 - maxImpact);           // ≈ 0.005025
//     const maxSafeSell = rMax * MEVav;
// console.log('getTotals 7');
//     // Table 1: Required liquidity for different sell amounts (1% impact)
//     const sellAmounts = [100, 200, 300, 400, 500, 750, 1000];
//     const liquidityTable = sellAmounts.map((x) => {
//       const requiredMEVav = x / rMax;
//       const requiredUSD   = requiredMEVav * price;
//       return { x, requiredMEVav: Math.round(requiredMEVav), requiredUSD: Math.round(requiredUSD) };
//     });
// console.log('getTotals 8');
//     // Table 2: Impact % for different sell sizes (current pool)
//     const impactAmounts = [10, 25, 50, 75, 100, 150, 200];
//     const impactTable = impactAmounts.map((x) => {
//       const r = x / MEVav;
//       const impact = (2 * r) / (1 + r) * 100;
//       return { x, impact: impact.toFixed(2) };
//     });
// console.log('getTotals 9');
//     return { price, maxSafeSell, liquidityTable, impactTable };
//   };

//   // Simple ASCII graph helpers
//   renderAsciiImpactGraph = (impactTable) => {
//     if (!impactTable.length) return null;
//     console.log('getTotals 10');
//     const maxImpact = Math.max(...impactTable.map(row => parseFloat(row.impact)));
//     const height = 10;
//     let lines = [];
// console.log('getTotals 11');

//     for (let y = height; y >= 0; y--) {
//       let line = '';
//       impactTable.forEach(({ x, impact }) => {
//         const barHeight = Math.round((parseFloat(impact) / maxImpact) * height);
//         line += barHeight >= y ? '█' : ' ';
//         line += '  ';
//       });
//       lines.push(line);
//       console.log('getTotals 12');
//     }

//     const xLabels = impactTable.map(({ x }) => x.toString().padStart(3)).join('  ');
//     console.log('getTotals 14');
//     return (
//       <pre style={{ fontSize: '12px', lineHeight: '1.1', margin: '10px 0' }}>
//         {lines.join('\n')}
//         {'─'.repeat(xLabels.length)}
//         {'\n'}{xLabels}
//         {'\nSell amount (MEV) →'}
//       </pre>
//     );
//   };

//   render() {
//     const { totalLc, totalGif, MEVav, WALLETCInUSD, loading, error } = this.state;

//     if (loading) return <div>Loading totals from Firebase...</div>;
//     if (error) return <div style={{ color: 'red' }}>{error}</div>;

//     const {
//       price,
//       maxSafeSell,
//       liquidityTable,
//       impactTable
//     } = this.calculateProjections();

//     return (
//       <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
//         <h2>System Totals & MEV Sell Projections</h2>

//         <div style={{ marginBottom: '24px' }}>
//           <strong>Current MEV Price:</strong> ${price.toFixed(4)} USD
//           <br />
//           <strong>Max safe sell per user/month (≤1% price impact):</strong> {maxSafeSell.toFixed(2)} MEV
//         </div>

//         {/* Current Totals */}
//         <h3>Live Values</h3>
//         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '32px' }}>
//           <div>Total Lc: {totalLc?.toFixed(2) ?? '—'} USD</div>
//           <div>MEVav: {MEVav?.toLocaleString() ?? '—'} MEV</div>
//           <div>Wallet C: {WALLETCInUSD?.toLocaleString(undefined, { minimumFractionDigits: 2 })} USD</div>
//           <div>Total GIF: {totalGif?.toFixed(2) ?? '—'} USD</div>
//         </div>

//         {/* Table 1: Required Liquidity */}
//         <h3>Required Liquidity for 1% Max Price Impact</h3>
//         <table style={{ borderCollapse: 'collapse', width: '100%', marginBottom: '32px' }}>
//           <thead>
//             <tr style={{ background: '#f0f0f0' }}>
//               <th style={{ padding: '8px', border: '1px solid #ddd' }}>Max Sell (MEV)</th>
//               <th style={{ padding: '8px', border: '1px solid #ddd' }}>Required MEVav</th>
//               <th style={{ padding: '8px', border: '1px solid #ddd' }}>Required Liquidity (USD)</th>
//             </tr>
//           </thead>
//           <tbody>
//             {liquidityTable.map((row, i) => (
//               <tr key={i}>
//                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.x}</td>
//                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.requiredMEVav.toLocaleString()}</td>
//                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>${row.requiredUSD.toLocaleString()}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Table 2: Impact at current liquidity */}
//         <h3>Price Impact % at Current Liquidity</h3>
//         <table style={{ borderCollapse: 'collapse', width: '60%', marginBottom: '16px' }}>
//           <thead>
//             <tr style={{ background: '#f0f0f0' }}>
//               <th style={{ padding: '8px', border: '1px solid #ddd' }}>Sell Amount (MEV)</th>
//               <th style={{ padding: '8px', border: '1px solid #ddd' }}>Price Impact (%)</th>
//             </tr>
//           </thead>
//           <tbody>
//             {impactTable.map((row, i) => (
//               <tr key={i}>
//                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.x}</td>
//                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.impact}%</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* ASCII Graph: Impact curve */}
//         <h4>Impact Curve (Current Pool)</h4>
//         {this.renderAsciiImpactGraph(impactTable)}

//         <p style={{ fontSize: '0.9em', color: '#666', marginTop: '32px' }}>
//           Projections assume constant price derivation (Liquidity / MEVav) and linear impact model. 
//           1% max price impact threshold used. Adjust in code if needed.
//         </p>
//       </div>
//     );
//   }
// }

// export default TotalsDashboard;

